import styled from "styled-components";
import Textbox from "../input";
import SubmitButton from "../submit";
import { AxiosError } from "axios";
import React, { FormEvent, LegacyRef, useState } from "react";
import { BE_BASE_URL } from "../../../utils/config";
import { useTranslation } from "react-i18next";
import { Color } from "../../../constants/color";
import Label from "../../label";
import { goToPage } from "../../../utils/utils";
import { axiosInstance } from "../../../provider/authProvider";
import { Link } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";

const FormWrapper = styled.form<{
  $error: boolean;
}>`
  order: 2;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  position: relative;
  min-width: 25rem;
  min-height: 20rem;
  height: ${(props) => (props.$error ? "530px" : "unset")};
  max-height: 500px;
  margin: 3.2rem auto auto;
  border-radius: 2rem;
  background-color: ${Color.WHITE};
  box-shadow: 0 0 8px 4px #e2e2e2;
  button {
    margin: auto;
  }
`;

<ToastContainer
  position="top-right"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick={false}
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="colored"
  transition={Bounce}
/>;

const Header = styled.h1`
  background-color: ${Color.LIGHT_BLUE};
  border-radius: 2rem 2rem 0 0;
  color: ${Color.WHITE};
  text-align: center;
  line-height: 80px;
  font-size: 20px;
  font-family: "Avenir Next Bold", sans-serif;
  margin: 2px 2px 0 2px;
`;

const ErrorMessage = styled.div<{
  $error: boolean;
}>`
  display: ${(props) => (props.$error ? "unset" : "none")};
  text-align: center;
  max-width: 20rem;
  height: 2rem;
  margin-top: 0.6rem;
  margin-left: 2.5rem;
  background-color: ${Color.PINK};
  border-radius: 0.6rem;
  border: 2px solid ${Color.RED};
  div {
    margin-top: 0.5rem;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
`;

const ResetPasswordForm = () => {
  const { t } = useTranslation();
  const formRef: LegacyRef<HTMLFormElement> | undefined = React.createRef();
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const resetPassword = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(
        BE_BASE_URL + "/user/resetPassword?email=" + encodeURIComponent(email)
      );
      if (response.status === 200) {
        const message = response.data.message;
        toast.success(message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          transition: Bounce,
        });
        setTimeout(() => {
          goToPage(`login?message=${message}`);
        }, 5000); // Il redirect avviene dopo 5 secondi
      }
    } catch (e: unknown) {
      const err = e as AxiosError;
      if (err.response && err.response.data) {
        const errorData = err.response.data as any;
        toast.error(errorData.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          transition: Bounce,
        });
        setTimeout(() => {
          goToPage(`login?message=${message}`);
        }, 5000); // Il redirect avviene dopo 5 secondi
      } else {
        setError(true);
      }
    }
  };
  return (
    <>
      <ToastContainer />
      <FormWrapper
        id="reset-password"
        ref={formRef}
        onSubmit={resetPassword}
        $error={error}
      >
        <Header>{t("reset-password-header")}</Header>
        <Textbox
          alt="email"
          label="Email"
          form="reset-password"
          autocomplete="email"
          name="email"
          placeholder={t("reset-password-placeholder-email")}
          type="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            width: "100%",
          }}
        >
          <div
            style={{
              order: 1,
              width: "100%",
              textAlign: "center",
              marginTop: "1rem",
            }}
          >
            <SubmitButton
              label={t("reset-password-email-submit")}
              form="reset-password"
              name="submit reset password"
              style={{
                padding: "0.5rem 1.5rem",
              }}
            />
          </div>
          <div
            style={{
              order: 2,
              width: "100%",
              textAlign: "center",
              marginTop: "1rem",
            }}
          >
            <LinkWrapper style={{ justifyContent: "center" }}>
              <Link
                style={{
                  color: Color.GREEN,
                  fontFamily: "Avenir Next, sans-serif",
                  fontWeight: "bold",
                }}
                to="/login"
              >
                {t("reset-password-login-link")}
              </Link>
            </LinkWrapper>
          </div>
        </div>
      </FormWrapper>
    </>
  );
};

export default ResetPasswordForm;
